import { GetObjectCommand } from '@aws-sdk/client-s3';

import { OutputErrorLog } from '../error';

import { s3Client } from './s3Client';

import { S3_BUCKET, S3_INPUT_BUCKET } from '@/utils/constant';

export type AccessS3Client = {
  Key: string;
  idToken: string;
  cognitoRoleARN: string;
  isInput?: boolean;
  maxByte?: number;
};

export const accessS3Client = async (input: AccessS3Client) => {
  try {
    const { Key, idToken, cognitoRoleARN, isInput = false } = input;
    const client = s3Client({ idToken, cognitoRoleARN });
    if (!client) {
      throw new Error('s3Client is null');
    }
    // GetObjectCommandを作成します。
    const command = new GetObjectCommand({
      Bucket: isInput ? S3_INPUT_BUCKET : S3_BUCKET,
      Key,
      Range: input.maxByte ? `bytes=0-${input.maxByte}` : undefined,
    });

    // S3からオブジェクトを取得します。
    const data = await client.send(command);

    // 取得したオブジェクトを読み取り可能なストリームに変換します。
    const readable = data.Body as ReadableStream;

    return readable;
  } catch (error) {
    OutputErrorLog('accessS3Client', error);
    return null;
  }
};
